const getPreviewInputId = (name) => `${name}-preview`;

export default getPreviewInputId;
